import { render } from "./Step3Component.vue?vue&type=template&id=1253d0b6&scoped=true"
import script from "./Step3Component.vue?vue&type=script&lang=js"
export * from "./Step3Component.vue?vue&type=script&lang=js"

import "./Step3Component.vue?vue&type=style&index=0&id=1253d0b6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1253d0b6"]])

export default __exports__